import { Component, OnInit , HostListener } from '@angular/core';
import { PersistanceService } from '@shared/services/persistance.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
  expandStatus: boolean = false;
  expandStatus2: boolean = false;
  expandStatus3: boolean = false;
  expandStatus4: boolean = false;
  expandStatus5: boolean = false;
  expandStatus6: boolean = false;
  expandStatus7: boolean = false;
  expandStatus8: boolean = false;
  expandStatus9: boolean = false;

  constructor(private persistanceService: PersistanceService) { }

  ngOnInit(): void {
  }

  logOut() {
    this.persistanceService.logOut()
  }

}
